import { render, staticRenderFns } from "./CustomerVehicleRadio.vue?vue&type=template&id=50a5460e"
import script from "./CustomerVehicleRadio.vue?vue&type=script&lang=ts"
export * from "./CustomerVehicleRadio.vue?vue&type=script&lang=ts"
import style0 from "./CustomerVehicleRadio.vue?vue&type=style&index=0&id=50a5460e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports